var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldRepeatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm15.03 4.18-1.69 1.69c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l.41-.41H9.1c-1.3 0-2.35-1.06-2.35-2.35v-1.77c0-.41.34-.75.75-.75s.75.34.75.75v1.77c0 .47.38.85.85.85h5.59l-.41-.41a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.69 1.69c.07.07.12.15.16.24.08.19.08.4 0 .58-.04.09-.09.17-.16.24zm-.53-3.71c-.41 0-.75-.34-.75-.75V9.95a.85.85 0 0 0-.85-.85H9.31l.41.4c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L6.97 8.87a.776.776 0 0 1-.16-.24.707.707 0 0 1 0-.57c.04-.09.09-.18.16-.25l1.69-1.69c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.41.41h5.59c1.3 0 2.35 1.06 2.35 2.35v1.78c0 .41-.34.75-.75.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRepeatCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-repeat-circle.71cd363f526890947b873744bceb1516.svg";
export { ForwardRef as ReactComponent };